module.exports = __webpack_public_path__ + "static/media/male-placeholder.2bbc7cfd.png";